import { PureComponent } from "react";

import { StyledDirectoryEmptyStateComponent } from "./directory-empty-state-component.scss";

export default class DirectoryEmptyStateComponent extends PureComponent {
  render() {
    return (
      <StyledDirectoryEmptyStateComponent className="directory-empty-state-component">
        <div className="empty-state-image-container">
          <img src="/static/img/empty-states/clouds-empty-state.png" />
        </div>

        <div className="empty-state-title">No results were found</div>

        <div className="empty-state-subtitle">
          What you are looking for is not being found, check your spelling of use a different word
        </div>
      </StyledDirectoryEmptyStateComponent>
    );
  }
}
